import React from 'react';
import { motion } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function Hero({
  onBookHotel
}: {
  onBookHotel?: () => void;
}) {
  return <section className="relative min-h-screen w-full flex flex-col items-center justify-center overflow-hidden bg-base px-4" data-id="element-181">
      {/* Background YouTube Video */}
      <div className="absolute inset-0 z-0 overflow-hidden" data-id="element-182">
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[180%] h-[180%] min-w-[180%] min-h-[180%] pointer-events-none" data-id="element-183">
          <iframe src="https://www.youtube.com/embed/o-bOka0jyNA?autoplay=1&mute=1&loop=1&playlist=o-bOka0jyNA&controls=0&showinfo=0&modestbranding=1&rel=0&iv_load_policy=3&disablekb=1&playsinline=1&enablejsapi=1" title="Euro Rastpark Himmelkron" className="w-full h-full border-0" allow="autoplay; encrypted-media" allowFullScreen data-id="element-184" />
        </div>
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-black/30" data-id="element-185" />
        {/* Gradient edges */}
        <div className="absolute inset-0 bg-gradient-to-t from-base/80 via-transparent to-transparent" data-id="element-186" />
      </div>

      {/* Ambient Glows */}
      <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-neon-purple/10 rounded-full blur-[120px] pointer-events-none z-[1]" data-id="element-187" />
      <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-electric-blue/10 rounded-full blur-[120px] pointer-events-none z-[1]" data-id="element-188" />

      <div className="relative z-10 max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-189">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: 'easeOut'
      }} className="mb-8" data-id="element-190">
          <span className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-black/20 backdrop-blur-xl border border-white/20 text-sm font-medium text-white/80 animate-float" data-id="element-191">
            <span className="w-2 h-2 rounded-full bg-neon-green animate-pulse" data-id="element-192" />
            Ausfahrt 39 · 24/7 geöffnet
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2,
        ease: 'easeOut'
      }} className="text-6xl md:text-8xl font-heading font-black tracking-tight mb-6 text-transparent bg-clip-text bg-gradient-to-b from-white to-white/60" data-id="element-193">
          Mehr als ein Halt.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4,
        ease: 'easeOut'
      }} className="text-xl md:text-2xl text-white/60 max-w-3xl mb-12 font-body" data-id="element-194">
          Casino · Restaurant · Hotel · Energie · Logistik – Alles an der A9.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.6,
        ease: 'easeOut'
      }} className="flex flex-col sm:flex-row gap-6 w-full sm:w-auto" data-id="element-195">
          <motion.div whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(14, 165, 233, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} className="rounded-xl" data-id="element-196">
            <button onClick={onBookHotel} className="px-8 py-4 rounded-xl bg-electric-blue text-white font-semibold text-lg transition-colors hover:bg-electric-blue/90" data-id="element-197">
              Hotel buchen
            </button>
          </motion.div>
          <motion.div whileHover={{
          scale: 1.05,
          boxShadow: '0 0 30px rgba(20, 184, 166, 0.4)'
        }} whileTap={{
          scale: 0.95
        }} className="rounded-xl" data-id="element-198">
            <a href="#/lkw-parken" className="inline-block px-8 py-4 rounded-xl bg-black/20 backdrop-blur-xl border border-white/20 text-white font-semibold text-lg transition-colors" data-id="element-199">
              Standplatz reservieren
            </a>
          </motion.div>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 1.2,
      duration: 1
    }} className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10" data-id="element-200">
        <motion.div animate={{
        y: [0, 10, 0]
      }} transition={{
        repeat: Infinity,
        duration: 2,
        ease: 'easeInOut'
      }} data-id="element-201">
          <ChevronDownIcon className="w-8 h-8 text-white/40" data-id="element-202" />
        </motion.div>
      </motion.div>
    </section>;
}